export const POINTS_LOG_RETRIEVED = 'user.POINTS_LOG_RETRIEVED';
export const POINTS_LOG_RETRIEVING = 'user.POINTS_LOG_RETRIEVING';
export const POINTS_LOG_ERROR = 'user.POINTS_LOG_ERROR';



// WEBPACK FOOTER //
// ./src/stores/points_log/action_types.js